import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { Link } from 'client/components/Trans/components/Link/Link'
import { Trans } from 'client/components/Trans/Trans'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type TProps = {
  contentMap: number[]
  ns: ClientLocaleNS
}

const TermsBlock: FC<TProps> = ({ contentMap, ns }) => {
  const { t } = useTranslation(ns)
  return (
    <div className="flex flex-col w-full gap-20">
      <ResponsiveBlock>
        <div className="flex flex-col gap-4">
          <Text tagName="h1" className="text-palette-white font-body---40px uppercase">
            {t('title')}
          </Text>
          <Text tagName="p" className="flex items-center gap-2 text-palette-grey--alt font-body---24px font-normal">
            {t('caption')}
          </Text>
        </div>
      </ResponsiveBlock>
      <ResponsiveBlock>
        <div className="flex w-full flex-col gap-12">
          {contentMap.map((listNumber, index) => {
            const itemNumber = index + 1
            return (
              <div key={index} className="flex flex-col w-full gap-2">
                <Text tagName="h4" className="text-palette-grey--alt font-body---24px font-normal">
                  {`${itemNumber}. ${t(`text_blocks.${itemNumber}.title`)}`}
                </Text>
                <Text tagName="span" className="text-palette-grey--alt font-body---24px font-normal">
                  <Trans
                    i18nKey={t(`text_blocks.${itemNumber}.caption`)}
                    ns={ns}
                    components={{ customLink: <Link /> }}
                  ></Trans>
                </Text>
                {listNumber > 0 && (
                  <ul className="flex flex-col gap-2">
                    {Array(listNumber)
                      .fill(null)
                      .map((_, listIndex) => {
                        const listItemNumber = listIndex + 1
                        return (
                          <li
                            key={listItemNumber}
                            className="inline gap-2 text-palette-grey--alt font-body---24px font-normal"
                          >
                            <Text
                              tagName="span"
                              className="font-mono leading-normal"
                            >{`${itemNumber}.${listItemNumber} `}</Text>
                            <Trans
                              i18nKey={t(`text_blocks.${itemNumber}.texts.${listItemNumber}`)}
                              ns={ns}
                              components={{ customLink: <Link /> }}
                            ></Trans>
                          </li>
                        )
                      })}
                  </ul>
                )}
              </div>
            )
          })}
        </div>
      </ResponsiveBlock>
    </div>
  )
}

export { TermsBlock }
